import { HOLD_STATUS, RESTORABLE_HOLD_STATUS, SELECT_ALL_HOLD_STATUS } from '../graphql/routePlanningOrderPoolHolding';

/**
 * 暂存状态筛选里的「全部」选项值。
 * 不能用空值表示全部：空值会被后端当成"未传"，回落到默认的「只看暂存中」。
 */
export const HOLD_STATUS_ALL = 'ALL';

/** 暂存状态筛选下拉的取值：'ALL' 或某个状态码的字符串形式 */
export type HoldStatusFilterValue = string;

/**
 * 筛选下拉的取值 → 下发给后端的状态码列表。
 *
 * @param filterValue 下拉当前值；'ALL' 表示全部状态
 * @returns 状态码列表，恒非空
 */
export function resolveHoldStatusValues(filterValue: HoldStatusFilterValue): number[] {
  if (filterValue === HOLD_STATUS_ALL) {
    return Object.values(HOLD_STATUS).slice().sort((a, b) => a - b);
  }
  const code = Number(filterValue);
  return Number.isNaN(code) ? [HOLD_STATUS.HOLDING] : [code];
}

/**
 * 该行能否被勾选。
 * <p>
 * 暂存页只放开 10-暂存中：20/30/40 是终态、15 正在后台处理中，勾了也移不回去，
 * 后端 `RESTORABLE_STATUS` 同样只认 10。规划池页签不受此限制。
 * </p>
 *
 * @param row 表格行，需要 orderId 与 holdStatus
 * @param isHoldingTab 当前是否在暂存运单池页签
 */
export function isHoldingRowSelectable(
  row: { orderId?: number; holdStatus?: number },
  isHoldingTab: boolean
): boolean {
  if (row.orderId == null) {
    return false;
  }
  if (!isHoldingTab) {
    return true;
  }
  return row.holdStatus != null && RESTORABLE_HOLD_STATUS.includes(row.holdStatus);
}

/**
 * 当前状态筛选下是否允许表头「全选」。
 * <p>
 * 全选是按筛选条件跨页下发的，筛到终态时全选只会得到一批移不回去的单子，所以要藏掉。
 * 保留 15-移回中：后台卡住超过阈值的批次可重新提交，「筛选移回中 + 全选」是该恢复路径在页面上的唯一入口。
 * </p>
 *
 * @param statusValues 当前下发的状态码列表
 */
export function isSelectAllAllowed(statusValues: number[]): boolean {
  return statusValues.length > 0 && statusValues.every((code) => SELECT_ALL_HOLD_STATUS.includes(code));
}
